import React from "react";
import {
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
// import useSortableList, { SortState } from "hooks/useSortableList";
// import { ArrowDownward, ArrowUpward, Sort } from "@mui/icons-material";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import ProcessItem, { StartedProcess } from "./ProcessItem";

interface ProcessesListProps {
  loading?: boolean;
  title: string;
  processes: Array<StartedProcess>;
  filters: Record<string, any>;
  lastElementRef: (node: any) => void;
  refresh: () => void;
}
const ProcessesList: React.FC<ProcessesListProps> = ({
  loading = true,
  processes = [],
  title,
  filters,
  lastElementRef,
  refresh,
}) => {
  // const [sort, setSort] = useState<Array<[string, SortState]>>([]);
  const translations = useTranslations();
  // useEffect(() => {}, [sort]);
  // const sortedProcesses = useSortableList(
  //   processes,
  //   "process_description",
  //   sort.process
  // );
  // const handleChangeSort = (key: string) => {
  //   // setSort((_) => {
  //   //   const fieldIndex = _.findIndex((v) => v[0] === key);
  //   //   if (fieldIndex) {
  //   //     switch(_[key]) {
  //   //       case SortState.None:
  //   //         return { ..._, [key]: SortState.Asc };
  //   //       case SortState.Asc:
  //   //         return { ..._, [key]: SortState.Desc };
  //   //       case SortState.Desc:
  //   //         return { ..._, [key]: SortState.None };
  //   //     }
  //   //   }
  //   // });
  // };
  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6">{title}</Typography>
      </Stack>
      <Table sx={{ width: "100%", tableLayout: "fixed" }}>
        <TableHead sx={{ "& th": { fontWeight: "bold" } }}>
          <TableRow>
            <TableCell>
              {/* <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
              > */}
              {getTranslation(translations, "generic.process")}
              {/* {sort === SortState.None && <Sort />}
                {sort === SortState.Asc && <ArrowUpward />}
                {sort === SortState.Desc && <ArrowDownward />} */}
              {/* </Stack> */}
            </TableCell>
            <TableCell>
              {getTranslation(translations, "generic.task")}
            </TableCell>
            {filters.status === "current" && (
              <TableCell>
                {getTranslation(translations, "pm.label.process_status")}
              </TableCell>
            )}
            <TableCell>
              {getTranslation(translations, "generic.user")}
            </TableCell>
            {/* {!filters.modelid && <TableCell>Process Model(n.t.)</TableCell>} */}
          </TableRow>
        </TableHead>
        <TableBody>
          {/* <Divider /> */}
          {!loading && processes.length <= 0 && (
            <TableRow>
              <TableCell
                colSpan={4}
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {getTranslation(translations, "generic.dataset.empty")}
              </TableCell>
            </TableRow>
          )}
          {processes.map((process, idx) =>
            idx === processes.length - 1 ? (
              <ProcessItem
                refresh={refresh}
                key={process.idprocesstoken}
                filters={filters}
                process={process}
                lastElementRef={lastElementRef}
              />
            ) : (
              <ProcessItem
                refresh={refresh}
                key={process.idprocesstoken}
                filters={filters}
                process={process}
              />
            )
          )}
          {loading && (
            <TableRow>
              <TableCell
                colSpan={4}
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </React.Fragment>
  );
};

export default ProcessesList;
